import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var CloseSmallSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.322 6.29a.99.99 0 011.4 0L12 10.568l4.277-4.278a.99.99 0 011.401 0l.032.031a.99.99 0 010 1.402L13.432 12l4.278 4.278a.99.99 0 010 1.401l-.032.032a.99.99 0 01-1.4 0L12 13.432 7.723 17.71a.99.99 0 01-1.401 0l-.032-.03a.99.99 0 010-1.402L10.568 12 6.29 7.723a.99.99 0 010-1.402l.032-.031z", fill: "currentColor" })] })));
};

export { CloseSmallSolidIcon };
//# sourceMappingURL=CloseSmallSolidIcon.js.map
